function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "desktop/header-signed-in",
  transform: "translate(-1222.000000, -24.000000)",
  fill: "#391D4D",
  stroke: "#391B4C"
}, /*#__PURE__*/React.createElement("g", {
  id: "profile",
  transform: "translate(1223.000000, 25.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.64285761,9.26857143 C9.64312399,9.03536699 9.52953235,8.81671642 9.33857143,8.68285714 C8.04996226,7.84836427 6.53384113,7.43501284 5,7.5 C3.46615887,7.43501284 1.95003774,7.84836427 0.661428571,8.68285714 C0.470467652,8.81671642 0.356876015,9.03536699 0.357142388,9.26857143 L0.357142388,11.0714286 L9.64285761,11.0714286 L9.64285761,9.26857143 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 5,
  cy: 2.85714286,
  r: 2.5
}))));

var SvgIconProfile = function SvgIconProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "13px",
    viewBox: "0 0 12 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Profile.49fd5f8f.svg";
export { ForwardRef as ReactComponent };